module.exports = __webpack_public_path__ + "static/media/B_E01.92d39ff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/B_E01.png
// module id = 112
// module chunks = 0